import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const ApprovalWaiting = () => {
    const { user, logout, getRedirectPath, loading } = useAuth();
    const navigate = useNavigate();

    React.useEffect(() => {
        if (loading) return;
        if (!user) {
            navigate('/role-selection');
            return;
        }

        const currentPath = getRedirectPath(user);
        if (currentPath !== '/onboarding/pending') {
            navigate(currentPath);
        }
    }, [user, loading, navigate, getRedirectPath]);

    return (
        <div className="max-w-2xl mx-auto py-12 px-4 text-center">
            <div className="bg-gray-800 rounded-2xl p-12 shadow-xl">
                <div className="w-20 h-20 bg-gold/10 rounded-full flex items-center justify-center mx-auto mb-8 animate-pulse">
                    <svg className="w-10 h-10 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>

                <h1 className="text-3xl font-bold text-white mb-4 italic uppercase tracking-wider">Approval Pending</h1>
                <p className="text-gray-400 text-lg mb-8 leading-relaxed">
                    Hello <span className="text-gold font-bold">{user?.name}</span>, thank you for submitting your documents!
                    Our team is currently reviewing your profile to ensure all requirements are met.
                    This process usually takes <span className="text-white font-medium">12-24 hours</span>.
                </p>

                <div className="bg-gray-900/50 rounded-xl p-6 mb-8 text-left">
                    <h2 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4">What happens next?</h2>
                    <ul className="space-y-3 text-sm text-gray-300">
                        <li className="flex items-start space-x-3">
                            <span className="text-gold mt-1">•</span>
                            <span>Our medical board will verify your license and credentials.</span>
                        </li>
                        <li className="flex items-start space-x-3">
                            <span className="text-gold mt-1">•</span>
                            <span>You'll be notified via email once your account is activated.</span>
                        </li>
                        <li className="flex items-start space-x-3">
                            <span className="text-gold mt-1">•</span>
                            <span>After activation, you'll have full access to your {user?.role} dashboard.</span>
                        </li>
                    </ul>
                </div>

                <div className="flex flex-col space-y-4">
                    <p className="text-sm text-gray-500">Need help? Contact us at support@vivara.com</p>
                    <button
                        onClick={logout}
                        className="text-gray-400 hover:text-white transition-colors text-sm underline underline-offset-4"
                    >
                        Logout and come back later
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ApprovalWaiting;
